import { NotificationItem } from "../../components-v2/notifications/types";

export const getOldestNotificationDate = (
  notifications: NotificationItem[]
): Date | null => {
  const oldestTimestamp = notifications.reduce<number | null>(
    (oldest, notification) => {
      const timestamp = new Date(notification.timestamp).getTime();

      if (Number.isNaN(timestamp)) {
        return oldest;
      }

      return oldest === null || timestamp < oldest ? timestamp : oldest;
    },
    null
  );

  return oldestTimestamp === null ? null : new Date(oldestTimestamp);
};

export const isNotificationInDateRange = (
  notification: NotificationItem,
  fromDate: Date,
  toDate: Date
): boolean => {
  const timestamp = new Date(notification.timestamp).getTime();

  if (Number.isNaN(timestamp)) {
    return false;
  }

  return timestamp >= fromDate.getTime() && timestamp <= toDate.getTime();
};
